export default class DataEmployee {
  static getConfig () {
    return [
      [
        {
          typeQuestion: 'description',
          titleQuestion: 'Уважаемый коллега компании САТ!',
          textQuestion: 'Мы исследовательское агентство Customer Service.<br/>' +
            'Компания САТ проводит опрос среди клиентов о качестве предоставляемых услуг с нашей помощью. В рамках этого исследования просим Вас ответить на вопросы об удовлетворенности клиентов, чтобы мы смогли всесторонне проанализировать качество опыта клиентов САТ. Ваше мнение очень важно для анализа. Опрос сотрудников компании САТ анонимный. Никакой идентификации анкет нет. Вы можете заполнять анкету с компьютера или смартфона – как Вам будет удобно. Заранее благодарим за сотрудничество!'
        },
        {
          typeQuestion: 'radio',
          textQuestion: 'Отметьте, пожалуйста, Дирекцию, в которой Вы работаете:',
          codeQuestion: 'S1',
          requiredQuestion: true,
          answers: [
            {value: 'Дирекция Информационных Технологий', point: 1},
            {value: 'Дирекция Коммерческой Деятельности', point: 2},
            {value: 'Дирекция Логистики', point: 3},
            {value: 'Дирекция Персонала', point: 4},
            {value: 'Дирекция Правового Обеспечения и Безопасности', point: 5},
            {value: 'Дирекция Финансов', point: 6},
            {value: 'Агентское Подразделение', point: 7},
            {value: 'Служба Генерального Директора', point: 8}
          ]
        }
      ],
      [
        {
          typeQuestion: 'description',
          textQuestion: '<b>Ниже перечислены критерии, которые назвали важными клиенты в работе перевозчиков.</b><br/>Как Вы считаете, насколько клиенты удовлетворены работой САТ по 10-ти балльной шкале, где 1 – самая низкая оценка, 10 – самая высокая:',
          titleQuestion: ''
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Удобством подачи заявки на отправку груза',
          'comment': '',
          'codeQuestion': 'Q1_R1',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Прозрачностью расчета стоимости груза',
          'comment': '',
          'codeQuestion': 'Q1_R2',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Скоростью обслуживания при оформлении груза',
          'comment': '',
          'codeQuestion': 'Q1_R3',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Скоростью доставки',
          'comment': '',
          'codeQuestion': 'Q1_R4',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Профессионализмом сотрудников',
          'comment': '',
          'codeQuestion': 'Q1_R5',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Количеством отделений',
          'comment': '',
          'codeQuestion': 'Q1_R6',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Системой уведомлений о статусе груза',
          'comment': '',
          'codeQuestion': 'Q1_R7',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Удобством оплаты услуг',
          'comment': '',
          'codeQuestion': 'Q1_R8',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Уровнем тарифов за услуги',
          'comment': '',
          'codeQuestion': 'Q1_R9',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Работой кол-центра',
          'comment': '',
          'codeQuestion': 'Q1_R10',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Услугой наложенных платежей',
          'comment': '',
          'codeQuestion': 'Q1_R11',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Рассмотрением рекламаций (жалоб, спорных вопросов)',
          'comment': '',
          'codeQuestion': 'Q1_R12',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Качеством обслуживания в отделениях',
          'comment': '',
          'codeQuestion': 'Q1_R13',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        }
      ],
      [
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Как Вы считаете, насколько в целом клиенты удовлетворены сотрудничеством с компанией САТ?',
          'comment': 'Оцените по 10-ти балльной шкале, где 1 - самая низкая оценка, 10 - самая высокая.',
          'codeQuestion': 'Q2_R1',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R1',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R2',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R3',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R4',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R5',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R6',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R7',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R8',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R9',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R10',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R11',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R12',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditorDependOn',
          'textQuestion': 'Вы отметили, что клиенты удовлетворены "{textQuestion}" на {point} баллов. Напишите, пожалуйста, почему Вы поставили такую оценку:',
          'comment': '',
          'codeQuestion': 'Q3',
          'requiredQuestion': true,
          'dependsOn': {
            'codeQuestions': 'Q1_R13',
            'ranges': {
              'from': 1,
              'to': 7
            }
          }
        }
      ],
      [
        {
          typeQuestion: 'description',
          textQuestion: 'Оцените, пожалуйста, насколько для клиентов в сотрудничестве с компанией-перевозчиком ВАЖЕН каждый из следующих критериев по 10-ти балльной шкале, где 1 – совсем не важно, 10 – очень важно:',
          titleQuestion: ''
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Удобство подачи заявки на отправку груза',
          'comment': '',
          'codeQuestion': 'Q4_R1',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Прозрачность расчета стоимости груза',
          'comment': '',
          'codeQuestion': 'Q4_R2',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Скорость обслуживания при оформлении груза',
          'comment': '',
          'codeQuestion': 'Q4_R3',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Скорость доставки',
          'comment': '',
          'codeQuestion': 'Q4_R4',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Профессионализм сотрудников',
          'comment': '',
          'codeQuestion': 'Q4_R5',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Количество отделений',
          'comment': '',
          'codeQuestion': 'Q4_R6',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Система уведомлений о статусе груза',
          'comment': '',
          'codeQuestion': 'Q4_R7',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Удобство оплаты услуг',
          'comment': '',
          'codeQuestion': 'Q4_R8',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Уровень тарифов за услуги',
          'comment': '',
          'codeQuestion': 'Q4_R9',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Работа кол-центра',
          'comment': '',
          'codeQuestion': 'Q4_R10',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Услуга наложенных платежей',
          'comment': '',
          'codeQuestion': 'Q4_R11',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Рассмотрение рекламаций (жалоб, спорных вопросов)',
          'comment': '',
          'codeQuestion': 'Q4_R12',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        },
        {
          'typeQuestion': 'radioHorizontal',
          'textQuestion': 'Качество обслуживанием в отделениях',
          'comment': '',
          'codeQuestion': 'Q4_R13',
          'requiredQuestion': true,
          'ranges': {
            'from': 1,
            'to': 10
          },
          'additionalAnswers': {
            'text': 'Затрудняюсь ответить',
            'point': 99
          }
        }
      ],
      [
        {
          'typeQuestion': 'textEditor',
          'textQuestion': 'Если у Вас есть еще какие-то пожелания относительно качества предоставляемых услуг компанией САТ, напишите о них, пожалуйста',
          'comment': '',
          'codeQuestion': 'Q9',
          'requiredQuestion': true
        },
        {
          'typeQuestion': 'btnFinish',
          'textQuestion': 'Завершить опрос',
          'comment': '',
          'codeQuestion': '',
          'requiredQuestion': false,
          'dependsOn': {
            'codeQuestions': 'Q9'
          }
        }
      ],
      [
        {
          typeQuestion: 'endDescription',
          textQuestion: '',
          titleQuestion: 'Благодарим за Ваше время и искренние ответы!'
        }
      ]
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/DataEmployee.js